/*
 * Feed
 * - Questionsx
 * - Answers
 *
 * @author: Elton Jain
 */
/* global require, define*/

define('Feed',[
    'jquery',
    'UI',
    'modules/common/Constants', // Site constants
    'Auth',
    'Helper',
    'JSTemplate', // Template engine
    'modules/common/Popup',
    'modules/Feed/FeedAction',
    'Config',
    'cookie'
], function($, UI, Constants, Auth, Helper, template, Popup, FeedAction, Config) {
    'use strict';

    var userData = Auth.getUser(),
        Feed = {
            $eleFeed: $('#feed'), // UL element
            feedType: 'latest', // latest | popular
            feedPage: 1, // Current feed page
            feedGroupId: null, // Group ID, if group page
            isGroupPage: /^(group|group.tv_episode)$/.test(Config.get('page.route')), // Group ID, if group page
            eventsBinded: false,
            isFeedLoading: false,
            init: function() {
                // Current Page
                this.feedPage = Helper.Url.getParam('page');
                this.feedPage = $.isNumeric(this.feedPage) ? this.feedPage : 1;

                // Current feed type
                // this.feedType = Helper.Url.getParam('type');
                // this.feedType = this.feedType ? this.feedType : 'latest';
                this.feedType = Helper.Url.getParam('type') || (Auth.check() ? 'latest' : 'popular');

                if (this.$eleFeed.attr('data-gid')) {
                    this.feedGroupId = this.$eleFeed.attr('data-gid');
                }
                // First time lazy load images
                Helper.loadFeedImages(this.$eleFeed);

                this.bindEvents();

                require(['FeedAskQuestion'], function(AskQuestion) {
                    new AskQuestion({
                        formPostQuestion: 'frmPostQuestion',
                        txtPostQuestion: 'txtPostQuestion',
                        postAttachments: 'postAttachments',
                        postFileSelect: 'postFileSelect',
                        btnPostAttach: 'btnPostAttach',
                        onPostQuestionCallback: Feed.onPostQuestionCallback
                    });
                });

                require(['FeedQuestions', 'FeedAnswers'], function(FeedQuestions, FeedAnswers) {
                    FeedQuestions.init();
                    FeedAnswers.init();
                    FeedAnswers.setLikeCountFunction(FeedQuestions.updateLikeCount); // Borrowing updateLikeCount function
                });

                require(['User'], function(User) {
                    User.init();
                });

                // require(['Mixpanel'], function(MixPanel) {
                //     if (Config.get('page.route') === 'home') {
                //         MixPanel.hit('count_load_more', {
                //             'home_feed': that.feedPage
                //         });
                //     } else if (Config.get('page.route') === 'group') {
                //         MixPanel.hit('count_load_more', {
                //             'topic_feed': that.feedPage
                //         });
                //     }
                // });
            },
            bindEvents: function() {
                var base = this;

                // Infinite loading
                // Max page = 5, only if logged in
                // Check scroll bottom,
                // Flag loading if loading
                // If completed, unbind
                
                if (/^(home|group|group.tv_episode|questionfollow|unanswered)$/.test(Config.get('page.route'))) {
                    UI.$w.on('scroll', Helper.debounce(function() {

                        // Doc height - 200 && 
                        var pageScrollHeight = UI.$d.outerHeight() - UI.$w.height();
                        if(window.scrollY >= pageScrollHeight-400 && 
                            window.scrollY > 100 && base.feedPage < 10) {
                            // && window.scrollY <= pageScrollHeight
                            if(base.isFeedLoading === false && $('#btnLoadMoreFeed').length > 0) {
                                base.isFeedLoading = true;
                                $('#btnLoadMoreFeed').trigger('click');
                            }
                        }
                    
                    }, 100));
                }

                // Feed Lazy Loading
                base.$eleFeed.on('click', '.load-more-feed', function(e) {
                    e.preventDefault();

                    if(base.feedPage >= 2 && !Auth.check()) {
                        Auth.showLoginPopup(true, {source: 'feed lazyload'});
                        return;
                    }

                    var $btn = $(this),
                        groupId = base.$eleFeed.data('gid') ? base.$eleFeed.data('gid') : null;

                    $btn.find('a').text('&nbsp').addClass('loading');
                    base.isFeedLoading = true;

                    base.loadMoreFeed({
                        page: $btn.data('page'),
                        isDetailPage: false,
                        groupId: groupId,
                        isNewPost: false,
                        callback: function() {
                            // $btn.removeClass('loading');
                            $btn.remove();
                            base.isFeedLoading = false;
                        }
                    });

                    e.stopImmediatePropagation();
                    return false;
                });

                // On click of feed article
                UI.$b.on('click','.feed-article-parent', function() {
                    var base = $(this),
                        url = base.data('url'),
                        questionId = base.data('article-id');

                    window.open(url,'_blank');

                    $.post('/ajax/track/user', {
                        type: 'feed_article',
                        targetId: questionId
                    }, function() {
                        require(['Mixpanel'], function (MixPanel) {
                            MixPanel.hit('click', {
                                target: 'feed article',
                                target_id: questionId
                            });
                        });
                    });

                });

                // Switch Feed type (latest / popular)
                UI.$b.on('click', '#feedTypeTelector > .option', function() {
                    var $btn = $(this),
                        type = $btn.data('type');

                    // Feed type changed
                    if (type !== base.feedType && !$btn.is('.checked')) {
                        base.feedType = type;
                        // base.feedGroupId = base.$eleFeed.data('gid');
                        $btn.addClass('loading');
                        $('#feed-wrap').data('first-load-time',parseInt(new Date().getTime()/1000));
                        base.resetFeed(true, function() {
                            $btn.removeClass('loading');
                            $btn.addClass('checked').siblings().removeClass('checked');
                        });

                        require(['Mixpanel'], function(MixPanel) {
                            MixPanel.hit('visit_page', {
                                'page': 'Feed',
                                'type': type
                            });
                            //MixPanel.hit('click', {target: 'feed ' + type});
                            return true;
                        });
                    }
                });

                UI.$b.off('click', '.related-question').on('click', '.related-question', function() {

                    var base = $(this);

                    require(['Mixpanel'],function(MixPanel) {
                        MixPanel.hit('click', {
                            'target': 'related questions',
                            'url': base.attr('href')
                        }, function() {
                            window.location = base.attr('href');
                        });
                    });

                    return false;

                });

                // Auto linking existing feed questions, only on q detail page
                if(/topic/.test(Config.get('page.route'))) {
                    Helper.linkifyFeedContent(base.$eleFeed.find('.q-text, .cmt-text'));
                }

                // Open preview photo
                UI.$b.on('click', '.q-image, .cmt-image', function(e) {
                    e.preventDefault();
                    if (!Auth.checkLoginRequired({source: 'feed comment image'})) {
                        return false;
                    }
                    var $ele = $(this),
                        photoData = [],
                        qaItem = null;

                    if($ele.is('.nsfw') === true) {
                        $ele.removeClass('nsfw');
                        return false;
                    }

                    if($ele.is('.q-image')) {
                        qaItem = window._gtap.data.f[$ele.parents('.feed-post').data('id')].topic;
                        var qaImages = qaItem.images;
                    } else if($ele.is('.cmt-image')) {
                        qaItem = window._gtap.data.fa[$ele.parents('.ans-item').data('id')];
                        var qaImages = qaItem.images;
                    } else {
                        return false;
                    }
                    if(!qaImages) {
                        return false;
                    }
                    
                    for(var i in qaImages) {
                        photoData.push({
                            src: qaImages[i].image,
                            w: qaImages[i].width,
                            h: qaImages[i].height,
                            title: "<strong>"+qaItem.user.fullname+"</strong><br/>"+
                                    qaItem.message.slice(0, 100)+"..."+
                                    "<br/><span class='txt-meta'>"+qaItem.nice_time+"</span>"
                        });
                    }
                    try {
                        // photoData = $.parseJSON(photoData);
                        require([
                            'History',
                            'vendor/photoswipe/photoswipe.min',
                            'vendor/photoswipe/photoswipe-ui.min'
                        ], function(History, PhotoSwipe, PhotoSwipeUI) {
                            // Photos on click
                            History.pushState({});
                            var photo = new PhotoSwipe($('#pswp')[0], PhotoSwipeUI, photoData, {
                                index: 0,
                            });
                            photo.init();
                        });
                    } catch (e) {}

                    return false;
                });

                if(Auth.check()) {
                    UI.$b.on('click', '.btn-q-like, .btn-answer-like', function(ev) {
                        if($(ev.target).hasClass('itm-action-count')) {
                            var $btn = $(this),
                            questionId = $btn.parents('.feed-post').data('id'),
                            answerId = $btn.data('ans') ? $btn.data('ans') : null,
                            data = {
                                answerId: answerId,
                                questionId: questionId,
                                page: 1
                            };
                            base.showLikePopup(data);
                        }
                    });
                }

                UI.$b.on('click', '.btn-q-share, .btn-answer-share', function(ev) {
                    var url = $(this).data('url'),
                        langs = Config.get('lang'),
                        message = $(ev.target).hasClass('btn-q-share') ? langs.share_q : langs.share_a;

                    Helper.showInvitePopup({
                        url: url,
                        message: message,
                        btn_text: 'Share via',
                        type: 'share',
                        content: $(ev.target).hasClass('btn-q-share') ? 'question' : 'answer'
                    });

                });

                UI.$b.on('click', '.card-banner', function() {
                    var base = $(this).find('a');
    
                    require(['Mixpanel'], function (MixPanel) {

                        MixPanel.hit('click', {
                            target: 'feed banner',
                            url: base.attr('href')
                        }, function() {
                            window.location = base.attr('href');
                        });


                    });
                    return false;
                });

                // On polling
                UI.$b.on('click','.feed-poll-options > .btn,.feed-poll-options > .poll-type-3',function() {

                    var user = Auth.getUser();

                    if(!user) {
                        Auth.showLoginPopup();  
                        return;
                    }

                    var base = $(this),
                        type3 = base.hasClass('poll-type-3'),
                        parent = base.closest('.feed-poll'),
                        pollChoices = (type3) ? parent.find('.poll-type-3') : parent.find('.btn'),
                        data = {
                            pollId: parent.data('poll-id'),
                            choiceId: base.data('choice-id')
                        },
                        pollTotalEl = parent.find('.feed-poll-total'),
                        totalVotes = parseInt(pollTotalEl.text()),
                        voted = false;


                    if(base.hasClass('selected')) {
                        return;
                    } else {
                        if(base.siblings('.btn.selected').length > 0 || base.siblings('.poll-type-3.selected').length > 0) {
                            voted = true;
                        }
                    }

                    parent.addClass('poll-submit');


                    $.post('/ajax/poll/vote',data,function(response) {

                        parent.removeClass('poll-submit');

                        var item,btn,
                            langs = Config.get('lang'),
                            poll = window._gtap.data.f[data.pollId];

                        if(response.status) {

                            pollChoices.removeClass('selected');

                            base.addClass('selected');

                            if(type3) {
                                parent.find('img').removeClass('selected');
                                base.find('img').addClass('selected');
                                if($(pollChoices[0]).find('.poll-type-3-choice').hasClass('hidden')) {
                                    parent.find('.poll-type-3-choice').removeClass('hidden');
                                    pollChoices.removeClass('hidden');
                                }
                            }

                            if(!voted) {
                                totalVotes++;
                                var temp = (totalVotes == 1) ? langs.vote : langs.votes; 
                                pollTotalEl.text(totalVotes + ' ' + temp);    
                            }

                            for(var i = 0;i < pollChoices.length;i++) {

                                item = response.response.votes[i];

                                btn = parent.find('[data-choice-id="' + item.choice_id + '"]');
                                btn.find('.poll-percentage').text(item.percentage + '%');
                                btn.find('.poll-meter').css('width',item.percentage + '%');
                            }

                            poll.already_voted = 1;
                            poll.total_votes = response.response.total_votes;
                            poll.votes = response.response.votes;

                            for(var i = 0;i < poll.poll_choices.length;i++) {
                                if(poll.poll_choices[i].id == data.choiceId) {
                                    poll.poll_choices[i].user_choice = 1;
                                } else {
                                    poll.poll_choices[i].user_choice = 0;
                                }
                            }


                            base.closest('.feed-poll-options').addClass('results');
                            parent.find('.feed-poll-meta').removeClass('hidden');
                        }
                    });


                });

                // On clicking play
                UI.$b.on('click','.feed-video',function() {
                    var parent = $(this),
                        videoId = parent.data('video-id'),
                        videoURL = Helper.getVideoUrl({videoId: videoId,autoplay: true,controls: true}),
                        questionId = parent.closest('.feed-post').data('id');
                    parent.append("<iframe src='"+videoURL+"' frameborder='0' class='videoplayer' allowfullscreen></iframe>");

                    $.post('/ajax/track/user',{
                        type: 'feed_video',
                        targetId: questionId
                    }, function() {
                        require(['Mixpanel'], function (MixPanel) {
                            MixPanel.hit('click', {
                                target: 'feed video',
                                target_id: questionId
                            });
                        });
                    });
                });


                // Actions
                UI.$b.on('click', '.post-itm-option', function() {
                    var $btn = $(this),
                        type = $btn.data('type'),
                        $question = $btn.parents('.feed-post'),
                        apiData = {},
                        url,
                        actions;

                    apiData.questionId = $question.data('id');
                    apiData.userId = $question.data('uid');
                    apiData.url = window._gtap.data.f[apiData.questionId]['hide_url'];
                    

                    if (type === 'answer') {
                        apiData.answerId = $btn.parents('.ans-item').data('id');
                        url = $btn.closest('.ans-item').data('url');
                        var ansData = window._gtap.data.fa[apiData.answerId];
                        if(ansData) {
                            actions = ansData.actions;
                        }
                    } else if(type === 'comment') {
                        url = '';
                        actions = $btn.data('actions');
                        apiData.commentId = $btn.parents('.cmt-item').data('id');

                    } else {
                        url = $btn.closest('.post-q').data('share-url');
                        var qData = window._gtap.data.f[apiData.questionId];
                        if(qData) {
                            actions = qData.actions;
                        }
                    }
                    var fa = new FeedAction(type);
                    fa.showActionMenu(actions, apiData, $btn, url, type);

                    require(['Mixpanel'], function (MixPanel) {
                        MixPanel.hit('click', {
                            target: 'feed qa options',
                            content: type,
                            content_id: type === 'answer' ? apiData.answerId : apiData.questionId
                        });
                    });
                    return false;
                });

                // Mixpanel event
                // Clicks
                UI.$b.on('click', '.feed-post .q-grp', function () {
                    require(['Mixpanel'], function(MixPanel) {
                        MixPanel.hit('click', {target: 'feed topic'});
                        return true;
                    });
                });

                UI.$b.on('click', '.feed-filter-selection', function() {
                    var base = $(this),
                        parent = base.parent('.feed-filter-parent');
                    parent.toggleClass('filter-expand');
                });

                UI.$b.on('click', '.feed-filter-options li', function() {
                    var base = $(this),
                        feed_filter = base.data('type');

                    if(feed_filter === $.cookie('feed_filter')) {
                        return;
                    }

                    $.removeCookie('feed_filter');

                    $.cookie('feed_filter', feed_filter, {expires:2});

                    require(['Mixpanel'], function(MixPanel) {
                        MixPanel.hit('click', {
                            target: 'feed filter',
                            type: feed_filter
                        });
                        window.location.reload();
                    });

                    

                });

                // Show auth popup when click to see load more answers
                // UI.$b.on('click','.link-load-more', function(e) {
                    
                //     if (!Auth.checkLoginRequired()) {
                //         return false;
                //     } else {
                //         return true;
                //     }
                // });

                // // On clicking likes
                // UI.$b.on('click', '.lbl-like-count', function() {

                //     if(!Auth.check()) {
                //         Auth.showLoginPopup();
                //         return false;
                //     }

                //     var html = template('tplLikeListContainer', {page: 1}),
                //     questionId = $(this).parents('.feed-post').data('id');
                //     $('body').append(html);

                //     require(['DataList','History'], function(DataList, History) {
                //         var dataList = new DataList(),
                //             loadmore = true;
                //         dataList.init({
                //             containerId: 'like-list',
                //             template: 'tplUserInvite',
                //             useApi: true,
                //             api: '/ajax/likes',
                //             apiData: {
                //                 questionId: questionId,
                //                 page: 1
                //             },
                //             customFuseField: 'users',
                //             onfetchCallback: function() {
                //                 $('#like-list').scroll(function(ev) {
                //                     if(loadmore) {
                //                         var that = this;
                //                         if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
                //                             $.post('/ajax/likes', {
                //                                 questionId: questionId,
                //                                 page: (parseInt($(this).data('page')) + 1)
                //                             },function(response) {
                //                                 if(response.status) {
                //                                     var html = template('tplUserInvite',{data: response.response.users,props: {}});
                //                                     $(that).append(html);
                //                                     $(that).data('page',parseInt($(that).data('page')) + 1);
                //                                     if(response.response.users.length < 10) {
                //                                         loadmore = false;
                //                                     }
                //                                 } else {
                //                                     loadmore = false;
                //                                 }
                                                
                //                             });
                //                         }
                //                     }
                //                 });
                //             }
                //         });

                //         History.pushState({
                //             url: '',
                //             popupId: 'like-list-container'
                //         });
                //         UI.noscroll();
                //     });
                // });                
            },
            showLikePopup: function(data) {

                var html = template('tplUserListContainer', 
                    {
                        page: 1, 
                        parentContainerId: 'like-list-container',
                        ulContainerId: 'like-list',
                        loadMoreId: 'loadMoreUsers'
                    });
                UI.$b.append(html);

                require(['DataList','History'], function(DataList, History) {
                    var dataList = new DataList();

                    dataList.init({
                        containerId: 'like-list',
                        template: 'tplUserInvite',
                        useApi: true,
                        api: '/ajax/likes',
                        apiData: data,
                        customFuseField: 'users',
                        lazyLoad: true,
                        elLazyButtonId: 'loadMoreUsers',
                        limitKey: 'user_limit',
                        onfetchCallback: function(results, o) {
                            if(o.customFuseField) {
                                data = results.response[o.customFuseField];
                            } else {
                                data = results.response;
                            }
                            if(data.length === 10) {
                                $('#' + o.elLazyButtonId).removeClass('hidden');
                            } else {
                                $('#' + o.elLazyButtonId).addClass('hidden');
                            }
                        }
                    });

                    History.pushState({
                        url: window.location.pathname + '',
                        popupId: 'like-list-container'
                    });
                    UI.noscroll();
                });
            },
            getFeedListRender: function(topicData, options) {
                var base = this,
                    feedTemplate = 'tplFeedList',
                    defaults = {
                        User: userData,
                        isDetailPage: false,
                        groupId: base.feedGroupId,
                        isGroupPage: base.isGroupPage,
                        page: 1,
                        isNewPost: false,
                    },
                    o = $.extend(defaults, options),
                    tmplData = {};

                // Data format
                // {topics: array(), isGroupPage: false, isDetailPage: false}
                tmplData = {
                    topics: topicData,
                    User: o.User,
                    isDetailPage: o.isDetailPage,
                    groupId: o.groupId,
                    isGroupPage: o.isGroupPage,
                    page: o.page,
                    isNewPost: o.isNewPost,
                    modules: {
                        Auth: Auth,
                        Config: Config,
                        Helper: Helper
                    }
                };

                if (Config.get('pageGroupData') && Config.get('pageGroupData.id')) {
                    tmplData.isGroupPage = true;
                }

                return template(feedTemplate, tmplData);
            },
            resetFeed: function(reload, callback) {
                var base = this;
                base.feedPage = 1;

                // Reload initial data after reset
                if (reload === true) {
                    base.loadMoreFeed({
                        afterFetch: function() {
                            base.$eleFeed.html('');
                        },
                        page: base.feedPage,
                        callback: callback
                    });
                } else {
                    base.$eleFeed.html('');
                    if (callback) {
                        callback();
                    }
                }
            },
            loadMoreFeed: function(options) {
                // Options = (page, empty feed/reset, type, groupId )

                var base = this,
                    defaults = {
                        page: base.feedPage,
                        isDetailPage: false,
                        groupId: base.feedGroupId,
                        isGroupPage: base.isGroupPage,
                        type: base.feedType,
                        api: '/ajax/feed/home/1',
                        afterFetch: null,
                        callback: null
                    },
                    o = $.extend(defaults, options),
                    firstLoadTime = $('#feed-wrap').data('first-load-time');

                o.api = o.groupId ? '/ajax/feed/group' : o.api;
                o.answers = null;

                if(Config.get('page.route') === 'unanswered') {
                    o.api = '/ajax/unanswered';
                    o.answers = (Helper.Url.getParam('answers') === '') ? 0 : Helper.Url.getParam('answers');
                    o.groupId = (Helper.Url.getParam('groupId') === '') ? 0 : Helper.Url.getParam('groupId');
                    o.countryId = (Helper.Url.getParam('countryId') === '') ? 0 : Helper.Url.getParam('countryId');
                } else if(Config.get('page.route') === 'questionfollow') {
                    o.api = '/ajax/questionfollow';
                }

                $.post(o.api, {
                    page: o.page,
                    type: o.type,
                    groupId: o.groupId,
                    countryId: o.countryId,
                    answers: o.answers,
                    firstLoadTime: firstLoadTime
                }, function(response) {
                    if (response.status === true && response.response) {
                        var renderedHtml = Feed.getFeedListRender(response.response, {
                                page: o.page,
                                groupId: o.groupId
                            }),
                            $renderedHtml = $(renderedHtml);

                        if (o.afterFetch) {
                            o.afterFetch();
                        }


                        base.$eleFeed.append($renderedHtml);
                        base.feedPage = o.page;
                        // Lazy load question image
                        Helper.loadFeedImages($renderedHtml);

                        require(['Mixpanel'], function(MixPanel) {
                            if (Config.get('page.route') === 'home') {

                                MixPanel.hit('count_load_more', {
                                    'home_feed': o.page
                                });
                            } else if (Config.get('page.route') === 'group' || Config.get('page.route') === 'group.tv_episode') {
                                MixPanel.hit('count_load_more', {
                                    'topic_feed': o.page
                                });
                            }
                        });

                    } else {
                        console.log(response.message);
                    }
                    // Generally, append data to the feed container
                    if (o.callback) {
                        o.callback();
                    }
                });
            },
            showGroupJoinPopup: function() {
                // From groups
                // Pass group Id and/or info
            }
        };


    Feed.onPostQuestionCallback = function(response, $formPostQuestion) {
        
        if (response.status === true) {
            // Render and add to the #Feed                                    
            var topicData = {feed: [response.response[0]]},
                $html = $(Feed.getFeedListRender(topicData, {
                    isDetailPage: false,
                    isNewPost: true
                }));
            if ($('.watermark').length > 0) {
                $('.watermark').remove();
            }

            // Scroll to new question
            UI.$b.animate({
                scrollTop: 0
            }, 'slow');

            Feed.$eleFeed.prepend($html);
            setTimeout(function () {
                Helper.loadFeedImages($html);
                Helper.linkifyFeedContent($html.find('.q-text'));
            }, 10);

        } else {
            if (response.status_code == Constants.status_code.no_auth_group && response.response) {
                var grp = response.response.group_info || {};
                require(['Groups'], function(Groups) {
                    Groups.showJoinGroupPopup({
                        image: grp.image,
                        id: grp.id,
                        name: grp.name,
                        url: grp.url
                    }, function() {
                        $formPostQuestion.submit();
                    });
                });

            } else {
                alert(response.message);
            }
        }
    };


    Feed.init();


    return Feed;
});
